<template>
  <esg-base-chart>
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart height="175"
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>

import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    productFamily: {
      type: Object,
      default: () => ({
        code: null,
        name: null
      })
    }
  },
  watch: {
    productFamily: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData();
      }
    }
  },
  data() {
    return {
      loading: false,
      categories: this.$store.getters['ghg/lifeCycleStages'],
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: { show: false },
          zoom: { enabled: false },
          events: {
            mounted: chart => chart.windowResizeHandler()
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '30%',
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
          labels: {
            show: false
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          x: {
            show: false,
          },
          y: {
            formatter: val => this.formatNumber(val, 2) + ' tCO2'
          }
        },
        grid: {
          show: false
        },
        legend: {
          show: true,
          position: 'bottom',
        },
      },
    }
  },
  methods: {
    async fetchData() {
      try {
        if (!this.productFamily || !this.productFamily.code || !this.productFamily.name) return

        this.loading = true

        let chartMeta = [{
          years: [new Date().getFullYear()],
          productFamilies: [this.productFamily.code],
          groupKeys: ['category']
        }]

        let param = new FormData();
        param.append('path', 'esg/lca/ghg_emission/main')
        param.append('json', JSON.stringify(chartMeta))

        let response = await axios.post('esg/lca/run/python/chart-data', param, {
          headers: { Authorization: accessToken() }
        });

        // If HTTP request fails, show an error
        if (!response.data.data) {
          this.$emit('noData')
          return
        }

        // Set the newly fetched data
        let chartData = JSON.parse(response.data.data)[0].data
        let series = []
        this.categories.forEach(category => {
          let ghg = chartData
              .filter(row => row.category === category.value)
              .map(row => row.values)
              .pop() || 0
          series.push({
            name: category.label,
            data: [ghg]
          })
        })
        this.series = series
      } catch (error) {
        this.loading = false
        await this.showError(error);
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
